import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function SiteLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Header />
      <main className="flex-1 w-full">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}